@if (isFilter()) {
  <button
    type="button"
    class="filter-trigger"
    [class.filter-trigger--active]="isOpen()"
    [class.filter-trigger--has-value]="!!effectiveSelectedText()"
    [class.is-valid]="isValid()"
    [class.is-invalid]="isInvalid()"
    [disabled]="selectDisabled()"
    (mousedown)="onTriggerPointerDown($event)"
    (keydown)="onTriggerKeyDown($event)"
    aria-haspopup="dialog"
    [attr.aria-expanded]="isOpen()"
  >
    <svg class="filter-trigger__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M3 9H21" stroke="currentColor" stroke-width="1.5"/>
      <path d="M9 4V9" stroke="currentColor" stroke-width="1.5"/>
      <path d="M15 4V9" stroke="currentColor" stroke-width="1.5"/>
    </svg>
    <span class="filter-trigger__text">{{ effectiveSelectedText() ?? placeholder() }}</span>
    <svg class="filter-trigger__chevron" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
} @else {
  <div
    class="so-date-range-picker__control"
    [class.so-date-range-picker__control--horizontal]="selectDisplay() === 'horizontal'"
    [style.maxWidth]="maxWidth()"
  >
    @if (selectLabel() && selectDisplay() !== 'horizontal') {
      <label class="form-style-label">{{ selectLabel() }}</label>
    }
    @if (selectLabel() && selectDisplay() === 'horizontal') {
      <label class="inline-label">{{ selectLabel() }}</label>
    }
    <div class="select-container">
      <button
        type="button"
        class="date-trigger"
        [class.date-trigger--open]="isOpen()"
        [class.is-valid]="isValid()"
        [class.is-invalid]="isInvalid()"
        [style.--so-select-height.px]="selectHeight()"
        [disabled]="selectDisabled()"
        (mousedown)="onTriggerPointerDown($event)"
        (keydown)="onTriggerKeyDown($event)"
        aria-haspopup="dialog"
        [attr.aria-expanded]="isOpen()"
      >
        @if (!effectiveSelectedText()) {
          <span class="date-trigger__placeholder">{{ placeholder() }}</span>
        }
        @if (effectiveSelectedText()) {
          <span class="date-trigger__value text-truncate">{{ effectiveSelectedText() }}</span>
        }
        <svg class="date-trigger__chevron" viewBox="0 0 24 24" fill="none">
          <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>
}

@if (isOpen()) {
  <div class="so-date-range-picker__overlay">
    <div class="so-date-range-picker__backdrop" (click)="onClose()"></div>
    <div
      #overlayPanel
      class="so-date-range-picker"
      [class.so-date-range-picker--filter]="isFilter()"
      (click)="$event.stopPropagation()"
      [style.top.px]="position()?.top ?? 0"
      [style.left.px]="position()?.left ?? 0"
      cdkTrapFocus
    >
      @if (isFilter() || selectLabel()) {
        <div class="so-date-range-picker__header">{{ selectLabel() || 'Fecha' }}</div>
      }
      <div class="so-date-range-picker__body">
        <div class="so-date-range-picker__presets">
          @for (preset of presets(); track $index) {
            @if (!preset.omit) {
              <button
                type="button"
                (click)="selectPreset($index)"
                class="so-text-2 flex-fill flex-grow-1 preset-button"
                [class.so-text-2-bold]="preset.active"
              >
                {{ preset.label }}
              </button>
            }
          }
        </div>
        <div class="so-date-range-picker__calendars">
          <div [ngClass]="showComplementaryCalendar() ? 'so-date-range-picker__content' : 'so-date-range-picker__content_simple'">
            <so-calendar-ui
              [selectedDateRange]="selectedDateRange()"
              (onChangeDateRange)="setDateRange($event)"
            ></so-calendar-ui>
            @if (showComplementaryCalendar()) {
              <so-calendar-ui></so-calendar-ui>
            }
          </div>
        </div>
      </div>

      <div class="so-date-range-picker__footer">
        @if (isFilter()) {
          <so-button-gradient-ui [text]="'Cancelar'" [variant]="'outline'" (clicked)="onClose(null)"></so-button-gradient-ui>
          <so-button-gradient-ui [text]="'Aplicar'" [variant]="'solid'" [color]="'secondary'" (clicked)="updateSelectedText()"></so-button-gradient-ui>
        } @else {
          <so-button-gradient-ui
            [text]="'Limpiar'"
            [variant]="'outline'"
            [color]="'danger'"
            (clicked)="onClose(null)"
          ></so-button-gradient-ui>
          <so-button-gradient-ui
            [text]="'Aplicar'"
            [variant]="'solid'"
            [color]="'secondary'"
            (clicked)="updateSelectedText()"
          ></so-button-gradient-ui>
        }
      </div>
    </div>
  </div>
}
